import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { KasseListView } from './list-view/kasse.list-view';

export const kasseFieldOk: FieldOkConfig = {
  name: 'kasse',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{kassennummer}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: KasseListView,
      },
    },
  ],
};
export const kasseMultiselectFieldOk: FieldOkConfig = {
  name: 'kasse',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{kassennummer}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: KasseListView,
      },
    },
  ],
};

export const kasseQueryFieldOk: FieldOkConfig = {
  name: 'kasse',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{kassennummer}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: KasseListView,
      },
    },
  ],
};
